import { calmTokens as t } from '../../../shared/tokens';
import { fmtDateShort } from '../../../shared/format';
import { IconUndo } from '../../../shared/icons';
import { Chip, PillButton } from './ui';
import { monoStyle } from './styles';

const KIND_OK = { color: '#86efac', bg: 'rgba(134,239,172,0.10)', border: 'rgba(134,239,172,0.28)' };
const KIND_CANCELLED = { color: '#6b6b76', bg: 'rgba(255,255,255,0.04)', border: 'rgba(255,255,255,0.08)' };

/** Historique des imports avec annulation. */
export default function ImportBatchList({ batches, onCancel, busy }) {
  if (!batches?.length) {
    return <div style={{ fontSize: 12, color: t.textMute }}>Aucun import pour le moment.</div>;
  }
  return (
    <div style={{ border: `1px solid ${t.border}`, borderRadius: 14, overflow: 'hidden', background: t.bg }}>
      {batches.map((b, i) => (
        <div
          key={b._id}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            padding: '11px 16px',
            borderTop: i ? `1px solid ${t.border}` : 'none',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ fontSize: 12, color: t.textDim, minWidth: 56, ...monoStyle }}>{fmtDateShort(b.createdAt)}</div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {b.fileName || 'Import CSV'}
            </div>
            <div style={{ fontSize: 11, color: t.textMute, ...monoStyle }}>
              {b.stats?.created ?? 0} nouvelles · {b.stats?.matched ?? 0} rapprochées · {b.stats?.skippedDuplicates ?? 0} doublons
            </div>
          </div>
          <Chip kind={b.status === 'committed' ? KIND_OK : KIND_CANCELLED}>
            {b.status === 'committed' ? 'Importé' : 'Annulé'}
          </Chip>
          {b.status === 'committed' && (
            <PillButton small danger icon={<IconUndo size={12} />} onClick={() => onCancel(b._id)} disabled={busy}>
              Annuler
            </PillButton>
          )}
        </div>
      ))}
    </div>
  );
}
